var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    className: "svg-opacity"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3478 8.26667C15.3478 10.0708 13.849 11.5333 12 11.5333C10.151 11.5333 8.65213 10.0708 8.65213 8.26667C8.65213 6.46254 10.151 5 12 5C13.849 5 15.3478 6.46254 15.3478 8.26667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0871 11.0667C21.0871 12.3553 20.0164 13.4 18.6958 13.4C17.3751 13.4 16.3045 12.3553 16.3045 11.0667C16.3045 9.77801 17.3751 8.73335 18.6958 8.73335C20.0164 8.73335 21.0871 9.77801 21.0871 11.0667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37229 13.4C6.69297 13.4 7.7636 12.3553 7.7636 11.0667C7.7636 9.77801 6.69297 8.73335 5.37229 8.73335C4.05161 8.73335 2.98099 9.77801 2.98099 11.0667C2.98099 12.3553 4.05161 13.4 5.37229 13.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78261 18.5333C5.78261 15.1883 8.57184 12.4667 12 12.4667C15.4283 12.4667 18.2175 15.1883 18.2175 18.5333C18.2175 18.7909 18.0032 19 17.7392 19H6.26088C5.99688 19 5.78261 18.7909 5.78261 18.5333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19681 14.4341C5.90411 14.3735 5.60662 14.3333 5.30437 14.3333C2.93123 14.3333 1 16.2177 1 18.5333C1 18.7909 1.21428 19 1.47828 19H4.91411C4.86053 18.8535 4.82609 18.6976 4.82609 18.5333C4.82609 17.0017 5.33881 15.5877 6.19681 14.4341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8032 14.4341C18.0959 14.3735 18.3934 14.3333 18.6956 14.3333C21.0688 14.3333 23 16.2177 23 18.5333C23 18.7909 22.7857 19 22.5217 19H19.0859C19.1395 18.8534 19.1739 18.6976 19.1739 18.5333C19.1739 17.0017 18.6612 15.5877 17.8032 14.4341Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.ad950b71.svg";
export { ForwardRef as ReactComponent };